/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {CustomValidator, ValidationError} from '../custom-validator.class';
import {ValidationMessage} from '../form-validator.class';

@Directive({
    selector: '[myRequiredFile]',
    providers: [{provide: NG_VALIDATORS, useExisting: MyRequiredFileValidatorDirective, multi: true}]
})
export class MyRequiredFileValidatorDirective implements CustomValidator {

    static ERROR_MESSAGE = new ValidationMessage('File is required.', 'Did you forget the <br/>supporting document?');

    @Input('myRequiredFile') type: string;

    private get critical(): boolean {
        return this.type !== 'warn';
    }

    validate(control: AbstractControl): {[key: string]: any} {
        return control.value == null || control.value.length === 0
            ? {requiredFile: new ValidationError(MyRequiredFileValidatorDirective.ERROR_MESSAGE, this.critical)}
            : null as any;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/requiredFile/required-file-validator.directive.ts